import type { LoginMutation } from '../hooks/useAuthenticate/useLogin/useLogin.generated';
import type { RegisterMutation } from '../hooks/useAuthenticate/useRegister/useRegister.generated';
import type { VerifyEmailLoginCodeMutation } from '../hooks/useEmailLoginCode/useEmailLoginCode.generated';

/** The payload of whichever mutation authenticated the user. */
export type AuthMutationData =
  LoginMutation | RegisterMutation | VerifyEmailLoginCodeMutation;

/**
 * Pulls the user out of whichever auth mutation ran.
 *
 * Each mutation names its payload after itself, so consumers of
 * `onAuthenticated` would otherwise each have to know all three shapes. Add new
 * auth mutations here rather than at the call sites.
 */
export const getAuthenticatedUser = (data: AuthMutationData | undefined) => {
  if (!data) {
    return undefined;
  }

  return (
    ('login' in data ? data.login : undefined) ||
    ('register' in data ? data.register : undefined) ||
    ('verifyEmailLoginCode' in data
      ? data.verifyEmailLoginCode.user
      : undefined)
  );
};
